<template>
  <b-modal :active.sync="active" has-modal-card :can-cancel="false">
    <div class="modal-card" style="overflow:visible;">
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
          <div class="column">
            <p class="modal-card-title">{{ titleModal }}</p>
          </div>
        </div>
      </header>
      <section class="modal-card-body" style="overflow:visible;">
        <div class="columns is-centered" style="width: 100%">
          <div class="column ">
            <h1 class="title is-5">Información Básica</h1>
            <b-field
              label="Nombre"
              :type="!isValid || !isNewHorse ? 'is-danger' : null"
              :message="[
                !isValid ? 'El nombre es un campo requerido' : null,
                !isNewHorse ? 'Ya existe un caballo con el mismo nombre y Género': null
              ]"
              label-position="inside"
            >
              <b-input
                type="text"
                v-model="horse.name"
                placeholder="Nombre"
                :loading="isSearching"
              >
              </b-input>
            </b-field>
            <b-field grouped>
              <b-field
                label="Fecha de Nacimiento"
                label-position="inside"
                expanded
              >
                <b-datepicker
                  v-model="birthDate"
                  :first-day-of-week="1"
                  :month-names="$moment.months()"
                  :day-names="$moment.weekdaysShort()"
                  :show-week-number="true"
                  placeholder="Click para seleccionar"
                  icon="calendar-today"
                >
                </b-datepicker>
              </b-field>
              <b-field label="Género" label-position="inside" expanded>
                <b-select
                  v-model="horse.gender"
                  placeholder="Seleccione un género"
                  expanded
                >
                  <option
                    v-for="option in genders"
                    :value="option.code"
                    :key="option.code"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
          <div class="column is-half">
            <div class="columns">
              <div class="column">
                <b-button expanded @click="close" :disabled="isLoading"
                  >Cerrar</b-button
                >
              </div>
              <div class="column">
                <b-button
                  type="is-primary"
                  expanded
                  @click="save"
                  :loading="isLoading"
                  >Guardar</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
var _ = require('lodash');
import HorseService from "@/services/HorseService";

export default {
  components: {},
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    gender: {
      type: String,
      require: false,
      default: null,
      validator: (value) => ['F', 'M'].indexOf(value) !== -1
    }
  },
  data() {
    return {
      isLoading: false,
      genders: [
        { code: "M", name: "Macho" },
        { code: "F", name: "Hembra" }
      ],
      birthDate: null,
      horse: {
        name: null,
        birth_date: null,
        gender: this.gender,
        horse_type_id: 1,
        active: false
      },
      isSubmit: false,
      isNewHorse: true,
      isSearching: false
    };
  },
  methods: {
    close() {
      this.birthDate = null;
      this.horse = {
        name: null,
        birth_date: null,
        gender: this.gender,
        horse_type_id: 1,
        active: false
      };
      this.isSubmit = false;
      this.isNewHorse = true;
      this.$emit("update:active", false);
    },
    success(message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      });
    },
    findHorse: _.debounce(async ( name, context ) =>{
      try {
        context.isSearching = true;
        const { data } = await HorseService.getParentHorses({
          gender: context.horse.gender,
          name: name
        })
        context.isSearching = false;

        const horses = data.data;

        context.isNewHorse = horses.length === 0;
        
        
      } catch (error) {
        console.log(error);
      }

    }, 500),
    async save() {
      this.isSubmit = true
      if (this.isValid && this.isNewHorse && !this.isSearching) {
        this.isLoading = true;
        let createdHorse = null;
        try {
          const { data } = await HorseService.createParentHorse(this.horse);

          createdHorse = data.data;

          console.log(createdHorse)
          setTimeout(() => {
            this.$emit("saved", createdHorse);
            this.close();
            this.isLoading = false;
          }, 3000);
          this.success("Caballo registrado exitosamente", "is-success");
          
        } catch (error) {
          console.log(error);
          this.success("Ha ocurrido un error", "is-danger");
          this.isLoading = false;
        }
      }
    }
  },
  watch: {
    birthDate(data) {
      this.horse.birth_date = this.$moment(data).isValid()
        ? this.$moment(data).format("YYYY-MM-DD")
        : null;
    },
    'horse.name'(value) {
      if( value ) {
        this.findHorse(value, this);
      }
    }
  },
  computed: {
    titleModal() {
      return this.horse.gender === 'F' ? 'Nueva Yegua Madre' : 'Nuevo Caballo Padre';
    },
    isValid() {
      return (this.horse.name && this.horse.name.length) || !this.isSubmit;
    }
  }
};
</script>
